module.exports = __webpack_public_path__ + "static/media/17.a995d7d0.jpg";